const sections = [
  {
    name: 'score',
    value: 10,
    color: '#00b300',
    tooltipBorder: '#00b300',
    textColor: '#FFF',
    score: 1,
    text: 'global.rating.class1',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#90ee90',
    tooltipBorder: '#90ee90',
    textColor: '#000000',
    score: 2,
    text: 'global.rating.class2',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#dfff00',
    tooltipBorder: '#dfff00',
    textColor: '#000000',
    score: 3,
    text: 'global.rating.class3',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#ffff00',
    tooltipBorder: '#ffff00',
    textColor: '#000000',
    score: 4,
    text: 'global.rating.class4',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#ffdf00',
    tooltipBorder: '#ffdf00',
    textColor: '#FFF',
    score: 5,
    text: 'global.rating.class5',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#ffbf00',
    tooltipBorder: '#ffbf00',
    textColor: '#FFF',
    score: 6,
    text: 'global.rating.class6',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#ff8000',
    tooltipBorder: '#ff8000',
    textColor: '#FFF',
    score: 7,
    text: 'global.rating.class7',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#ff4000',
    tooltipBorder: '#ff4000',
    textColor: '#FFF',
    score: 8,
    text: 'global.rating.class8',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#ff1a00',
    tooltipBorder: '#ff1a00',
    textColor: '#FFF',
    score: 9,
    text: 'global.rating.class9',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#cc0000',
    tooltipBorder: '#cc0000',
    textColor: '#FFF',
    score: 10,
    text: 'global.rating.class10',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#4d4d4d',
    tooltipBorder: '#4d4d4d',
    textColor: '#FFF',
    score: 11,
    text: 'global.rating.class11',
    active: false,
  },
  {
    name: 'score',
    value: 10,
    color: '#000000',
    tooltipBorder: '#000000',
    textColor: '#FFF',
    score: 12,
    text: 'global.rating.class12',
    active: false,
  },
];

export default sections;
